// next.config.js `images.deviceSizes` + `images.imageSizes`; Next yalnız bu genişlikleri kabul eder.
const ALLOWED_WIDTHS = [64, 128, 256, 384, 640, 768, 1024, 1280];

/**
 * Firebase Storage görselini Next görsel uç noktasından küçültülmüş (AVIF/WebP) ister.
 * Yüklenen orijinaller 0,5–1 MB; liste kartında 56–160 px gösterildiği için 2× genişlik yeterli.
 * Storage dışı adresler (yerel `/images/*`, boş değer) olduğu gibi döner.
 */
// Profil yüklemesinin ürettiği gerçek küçük resim (256 px, `resimler/profilepic/mini/`): Vercel
// dönüşümü (Hobby 5.000/ay) harcamadan doğrudan kullanılır.
const PROFILE_THUMB_PATH = '/o/resimler%2Fprofilepic%2Fmini%2F';
const PROFILE_THUMB_MAX_DISPLAY = 128;

// Boş girdide `undefined`: antd Avatar boş metni adres sayıp kırık <img> çizer; undefined'da baş harfe düşer.
export function storageImage(src: string | undefined | null, displayWidth: number): string | undefined {
  if (!src) return undefined;
  if (!src.startsWith('https://firebasestorage.googleapis.com/')) return src;
  if (src.includes(PROFILE_THUMB_PATH) && displayWidth <= PROFILE_THUMB_MAX_DISPLAY) return src;
  const target = displayWidth * 2;
  const width = ALLOWED_WIDTHS.find(item => item >= target) || ALLOWED_WIDTHS[ALLOWED_WIDTHS.length - 1];
  return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=75`;
}
